import vueUIInitiator from '../../../modules/vue-ui-initiator';
import PurchasesTable from '../../../vue-components/PurchasesTable';

vueUIInitiator('js--purchases-table', PurchasesTable, 'purchases-table');
